import React, {useEffect, useState, useMemo, useRef} from "react";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus } from "@fortawesome/free-solid-svg-icons";
// import { Button, Modal } from "react-bootstrap";
// import Modal from "admin/common/Modal";
import { Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { apiUrl, assetsUrl } from "../../config/Config";
import moment from 'moment';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import Swal from 'sweetalert2';
import Editor from "../../components/Editor";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

const AllPayments = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const userdata = useSelector((store) => store.userReducer.userdata);
    const [showloding, setshowloding] = useState(false);
    const [showmodal, setshowmodal] = useState(false);
    const [editshowmodal, seteditshowmodal] = useState(false);
    const [selectedid, setselectedid] = useState(0);

    const [name, setname] = useState("");

    const [title, settitle] = useState("");
    const [datecheck, setdatecheck] = useState(false);


    const selectedidRef = useRef(0);
    selectedidRef.current = selectedid;



    const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const paginationPageSizeSelector = useMemo(() => {
    return [10, 20, 50, 100];
  }, []);

  const [showuserloading, setshowuserloading] = useState(false);
  const [showusermodal, setshowusermodal] = useState(false);
  const [usersdata, setusersdata] = useState([]);

  const [sendmessagetext, setsendmessagetext] = useState("Thank you for your contribution to TheOmSaga. By divine grace, your offering has reached the sacred destination and is serving the needy at XYZ");
  const [showtriggermodal, setshowtriggermodal] = useState(false);
  const [showtriggerloading, setshowtriggerloading] = useState(false);
  const [editorLoaded, setEditorLoaded] = useState(true);

  const usersdataRef = useRef([]);
  usersdataRef.current = usersdata;

  function formatDateWithOrdinal(dateString) {
    const date = new Date(dateString);
  
    const day = date.getDate();
  
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
  
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
  
    return `${day}${getOrdinal(day)} ${months[date.getMonth()]} ${date.getFullYear()}`;
  }
  

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // console.log(baseURL);
        resolve(baseURL);
      };
      // console.log(fileInfo);
    });
  };

  const submithandle = async () => {
    if (sendmessagetext) {
      setshowtriggerloading(true);
      var data = {
        id: selectedidRef.current,
        message: sendmessagetext
    };
    console.log('sendtriggermessage data >>', data);
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .post(apiUrl + "sendtriggermessage", data, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            setshowtriggermodal(false);
            setsendmessagetext("");
            fetchallcourses();
            setshowtriggerloading(false);
          } else {
            if(res.data.message == "invalid user") {
              dispatch({ type: "userdata", payload: {} })
              navigate('/login');
            } else {
                Swal.fire({
                  title: '',
                  text: res.data.message,
                  icon: 'error',
                  customClass: {
                    icon: 'custom-swal-icon' // Apply the custom class
                  },
                  width: '350px',
                  confirmButtonText: 'Ok',
              confirmButtonColor: "rgb(59, 151, 196)",
                  customClass: {
                      popup: "small-icon-alert",
                    },
                });
            }
            setshowtriggerloading(false);
          }
        })
        .catch((err) => {
          setshowtriggerloading(false);
          alert(err.message);
        });
        setshowtriggerloading(false);
    } else {
      Swal.fire({
        title: '',
        text: "Empty Field",
        icon: 'error',
        customClass: {
          icon: 'custom-swal-icon' // Apply the custom class
        },
        width: '350px',
        confirmButtonText: 'Ok',
    confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
            popup: "small-icon-alert",
          },
      });
    }
  };

      const deletecourse = async (id, title) => {
        console.log('id >>', id);
        const result = window.confirm("Are you sure you want to delete service " + title);
        if (result) {
          var data = JSON.stringify({
            id: id,
          });
          const headers = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + userdata?.token,
            },
          };
          let resp = await axios
            .post(apiUrl + "deleteservice", data, headers)
            .then((res) => {
              if (res.data.status == "success") {
                fetchallcourses();
              } else {
              }
            })
            .catch((err) => {
              alert(err.message);
            });
        } else {
          // User clicked Cancel or closed the dialog
          // console.log("User clicked Cancel");
        }
      };

      const defaultColDef = {
        flex: 1,
        resizable: false,
      };


      const handleCheckboxChange = async(t, id, title) => {
        // console.log('t >>', t.target.checked);
        if(!t.target.checked) {
          const result = window.confirm('Are you sure you want to disable user "' + title + '"');
          if(result) {

          } else {
            return
          }
        }
        
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    var data = {
      'id': id,
      'status': t.target.checked ? 'true': 'false'
    }
    let resp = await axios
    .post(apiUrl + "updateregisteruserstatus", data, headers)
    .then((res) => {
      if (res.data.status == "success") {
        fetchallcourses();
        setshowloding(false);
      } else {
        if(res.data.message == "invalid user") {
          dispatch({ type: "userdata", payload: {} })
          navigate('/admin/login');
        } else {
          Swal.fire({
            title: '',
            text: res.data.message,
            icon: 'error',
            customClass: {
              icon: 'custom-swal-icon' // Apply the custom class
            },
            width: '350px',
            confirmButtonText: 'Ok',
        confirmButtonColor: "rgb(59, 151, 196)",
            customClass: {
                popup: "small-icon-alert",
              },
          });
        }
      }
    })
    .catch((err) => {
      alert(err.message);
    });
  setshowloding(false);
    console.log('data >>', data);
      }

      const handleclickonusers = async(data) => {
        console.log('handleclickonusers data >>', data);
        setshowuserloading(true);
        setshowusermodal(true);
        const headers = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + userdata?.token,
            },
          };
        var formdata = {
            bucketid: data?.bucketId
        }
          let resp = await axios
          .post(apiUrl + "admingetpaymentuserslist",formdata, headers)
          .then((res) => {
            if (res.data.status == "success") {
                if(res.data.data?.length > 0) {
                    setusersdata(res.data.data);
                } else {
                    setusersdata([]);
                }
                setshowuserloading(false);
            } else {
                setshowuserloading(false)
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/login');
              } else {
                Swal.fire({
                  title: '',
                  text: res.data.message,
                  icon: 'error',
                  customClass: {
                    icon: 'custom-swal-icon' // Apply the custom class
                  },
                  width: '350px',
                  confirmButtonText: 'Ok',
              confirmButtonColor: "rgb(59, 151, 196)",
                  customClass: {
                      popup: "small-icon-alert",
                    },
                });
              }
            }
          })
          .catch((err) => {
            alert(err.message);
            setshowuserloading(false)
          });
          setshowuserloading(false)
      }

      const handlesendmessagefunc = async(data) => {
        console.log('handlesendmessagefunc >>', data);
        setselectedid(data?.id);
        setshowtriggermodal(true);
      }


    const fetchallcourses = async () => {
        setshowloding(true);
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .get(apiUrl + "admingetallpayments", headers)
          .then((res) => {
            if (res.data.status == "success") {
              // console.log('getallcategories >>', res.data);
              var prevdata = res.data.data;
              if(prevdata?.length > 0) {
                var columnsarr = [];
                var hidecolumns = ['id', 'created_at', 'updated_at', 'sort', 'image', 'status', 'categoryid', 'description', 'facebook', 'twitter', 'linkedin', 'instagram', 'pinterest', 'slug', 'points', 'type', 'is_date_time', 'bucketId', 'userid', 'isemailsent'];
                var columns = Object.keys(prevdata[0]);
                // console.log('columns  >>>', columns );
                for(var i = 0; i < columns?.length;i++) {
                  if(!hidecolumns.includes(columns[i])) {
                    var obj = {};
                    if(columns[i] == "totalAmount") {
                        obj.maxWidth = 250;
                    }
                    obj.field = columns[i];
                    obj.filter = true;
                    obj.filterParams = {
                      filterOptions: ["contains"],
                      maxNumConditions: 1,
                    };
                    // console.log('obj >>', obj)
                    columnsarr.push(obj);
                  }
                }

                //users
             var usersobj = {
                field: "users",
                headerName: "Users",
                maxWidth: 150,
                cellRenderer: (props) => {
                   // console.log('props >>', props?.data)
                   if(props?.data?.userid) {
                    var prevarr = JSON.parse(props?.data?.userid);
                    var usercount = prevarr?.length;
                   } else {
                    var usercount = 0
                   }
                   return (
                    <div className="d-flex" style={{cursor: 'pointer'}} onClick={() => {handleclickonusers(props?.data)}}>
                      <p>{usercount}</p>
                    </div>
                  );
                },
              };
              columnsarr.push(usersobj);
               

                

                 //status
            //  var statusobj = {
            //     field: "status",
            //     headerName: "Status",
            //     maxWidth: 150,
            //     cellRenderer: (props) => {
            //        // console.log('props >>', props?.data)
            //        return (
            //         <div className="d-flex">
            //           <div class="form-check">
            //             <input
            //             onChange={(t) => {handleCheckboxChange(t, props?.data?.id, props?.data?.fullName)}}
            //               type="checkbox"
            //               class="form-check-input tableformcheck"
            //               id="check1"
            //               name="option1"
            //               value="something"
            //               style={{marginTop: 12}}
            //               checked={props?.data?.status == 'true' || props?.data?.status == true ? true : false}
            //             />
            //           </div>
            //         </div>
            //       );
            //     },
            //   };
            //   columnsarr.push(statusobj);

            // Email sent Button
            var emailsentstatusobj = {
              field: "isnotified",
              headerName: "Is Notified",
              maxWidth: 220,
              cellRenderer: (props) => {
                 // console.log('props >>', props?.data)
                 return (
                  <div className="d-flex">
                    {
                    props?.data?.isemailsent == false ||  props?.data?.isemailsent == "false" ?
                      <p>Not Sent</p> :
                      <p>Sent</p>
                    }
                  </div>
                );
              },
            };
            columnsarr.push(emailsentstatusobj);

            //Trigger Button
            var emailobj = {
              field: "action",
              headerName: "Action",
              maxWidth: 220,
              cellRenderer: (props) => {
                 // console.log('props >>', props?.data)
                 return (
                  <div className="d-flex">
                    <div class="form-check" style={{paddingLeft: 0}}>
                      <div className="trigger-email-btn" 
                      style={{cursor: 'pointer'}}
                      onClick={() => {handlesendmessagefunc(props?.data)}}
                      >
                        <p>Send</p>
                      </div>
                    </div>
                  </div>
                );
              },
            };
            columnsarr.push(emailobj);
              
                //edit
            //   var editobj = 
            //   {
            //     field: "edit",
            //     headerName: "Edit",
            //     maxWidth: 150,
            //     cellRenderer: (props) => {
                  
            //       return (
            //         <div
            //               onClick={() => {
            //                 editlocation(props?.data);
            //                 // console.log('props >>', props?.data);
            //               }}
            //               style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
            //             >
            //               <FontAwesomeIcon
            //                 icon={faPenToSquare}
            //                 className="sidebaricons"
            //                 style={{ color: "blue" }}
            //               />
            //             </div>
            //       )
            //     },
            //     cellRendererParams: {
            //       onClick: clickhandle,
            //     },
            //   }
            //   columnsarr.push(editobj);

                //delete
                // var deleteobj = 
                // {
                //   field: "delete",
                //   headerName: "Delete",
                //   cellRenderer: (props) => {
                    
                //     return (
                //       <div
                //             onClick={() => {
                //               deletecourse(props?.data?.id, props?.data?.title);
                //               // console.log('props >>', props?.data);
                //             }}
                //             style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                //           >
                //             <FontAwesomeIcon
                //               icon={faTrash}
                //               className="sidebaricons"
                //               style={{ color: "red" }}
                //             />
                //           </div>
                //     )
                //   },
                //   cellRendererParams: {
                //     onClick: clickhandle,
                //   },
                // }
                // columnsarr.push(deleteobj);
                setColDefs(columnsarr);
                setRowData(prevdata);
              } else {
                setColDefs([]);
                setRowData([]);
              }
              
              // setcoursesdata(res.data.data);
            } else {
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/login');
              } else {
                Swal.fire({
                  title: '',
                  text: res.data.message,
                  icon: 'error',
                  customClass: {
                    icon: 'custom-swal-icon' // Apply the custom class
                  },
                  width: '350px',
                  confirmButtonText: 'Ok',
              confirmButtonColor: "rgb(59, 151, 196)",
                  customClass: {
                      popup: "small-icon-alert",
                    },
                });
              }
            }
          })
          .catch((err) => {
            alert(err.message);
          });
          setshowloding(false);
      };
    useEffect(() => {
            if (userdata && Object.keys(userdata).length > 0) {
              //   fetchdata();
              fetchallcourses();
            } else {
              navigate("/login");
            }
          }, []);
    return (
      <div className="adminmainpagelayout">
        <div className="productstogglebar mt-2">
          {/* <div
            className="filterdiv couponfilterdiv"
            onClick={() => {
              settitle("");
              setdatecheck(false);
              setshowmodal(true);
            }}
          >
            <FontAwesomeIcon
              icon={faPlus}
              className="iconstyles"
              style={{ color: "#64748B" }}
            />
            <p>Add New</p>
          </div> */}
        </div>

        <div
          className={"ag-theme-quartz"}
          style={{ width: "100%", height: 500, marginTop: 15 }}
        >
          <AgGridReact
            // modules={AllModules}
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            suppressRowClickSelection={true}
            groupSelectsChildren={true}
            rowSelection={"multiple"}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={paginationPageSizeSelector}
            // onGridReady={onGridReady}
          />
        </div>

        {/* Users Modal */}
        <Modal
          show={showusermodal}
          onHide={() => setshowusermodal(false)}
          size={showuserloading ? "md" : "xl"}
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>
              Users in this Milestone
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              {showuserloading ? (
                <div className="spinner_all_payments">
                  <Spinner
                    color="#d65300"
                    size={17}
                    className="spinnerCenter"
                  />
                </div>
              ) : usersdataRef.current?.length > 0 ? (
                <table class="table table-bordered mt-3">
                  <thead>
                    <tr>
                      <th>Full Name</th>
                      <th>Email</th>
                      <th>Number</th>
                      <th>Amount</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usersdataRef.current?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item?.fullname}</td>
                          <td>{item?.email}</td>
                          <td>{item?.number}</td>
                          <td>{item?.contri_amount}</td>
                          <td>{formatDateWithOrdinal(item?.created_at)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <p style={{ textAlign: "center" }}>No data to show</p>
              )}
            </div>
          </Modal.Body>
        </Modal>

        {/*Send Message modal */}
        <Modal
          show={showtriggermodal}
          onHide={() => setshowtriggermodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Trigger Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="">
                <label className="addproduct-label">Message</label>
                <Editor
                  value={sendmessagetext}
                  onChange={(data) => setsendmessagetext(data)}
                  editorLoaded={editorLoaded}
                />
              </div>

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    if(showtriggerloading) {

                    } else {
                      submithandle();
                    }
                    
                  }}
                >
                  {
                    showtriggerloading ?
                    <Spinner
                    color="#fff"
                    size={17}
                    className="spinnerCenter"
                  /> :
                    <p>Submit</p>
                  }
                  
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
}

export default AllPayments